import React from "react";

class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedY: false,
      checkedN: false,
      checkedNA: false,
    };
  }
  handlechange = (name) => {
    if (name == "yes") {
      this.setState({ checkedY: true, checkedN: false, checkedNA: false });
    } else if (name == "no") {
      this.setState({ checkedY: false, checkedN: true, checkedNA: false });
    } else if (name == "ga") {
      this.setState({ checkedY: false, checkedN: false, checkedNA: true });
    }
  };
  render() {
    return (
      <div>
        <label style={{ fontWeight: "bold", marginRight: "5px" }}>Yes</label>
        <input
          style={{ marginRight: "10px" }}
          type="checkbox"
          name="yes"
          checked={this.state.checkedY}
          onClick={() => this.handlechange("yes")}
        />
        <label style={{ fontWeight: "bold", marginRight: "5px" }}>No</label>
        <input
          style={{ marginRight: "10px" }}
          type="checkbox"
          name="no"
          checked={this.state.checkedN}
          onClick={() => this.handlechange("no")}
        />
        <label style={{ fontWeight: "bold", marginRight: "5px" }}>
          {this.props.label ? "Not Sure" : "GA"}
        </label>
        <input
          style={{ marginRight: "10px" }}
          type="checkbox"
          name="ga"
          checked={this.state.checkedNA}
          onClick={() => this.handlechange("ga")}
        />
      </div>
    );
  }
}
export default CheckBox;
